import React from "react";
import Sidebar from "./Sidebar";
import Header from "./Header";
import AdminNav from "./AdminNav";

/**
 * Shell for every admin console page: the app chrome, a constant "Admin"
 * heading, and the section rail beside the content. Pages render only their own
 * heading and body as `children` and keep their own routes.
 *
 * The two-level heading is deliberate — "Admin" names the console and stays
 * put, while each page names itself in an <h2> inside the content column, so
 * the rail and the heading never contradict each other.
 */
export default function AdminLayout({ children, overlays }) {
    return (
        <div className="home-layout">
            <Sidebar activePage="Admin" />
            <main className="home-main">
                <Header />
                <div className="home-content">
                    <div>
                        <h1 className="upload-page-heading">Admin</h1>
                        <p className="upload-page-meta">Manage users, sections, and platform tools</p>
                    </div>

                    <div className="admin-console-body">
                        <AdminNav />
                        <div className="admin-console-main">{children}</div>
                    </div>
                </div>
            </main>
            {/* Modals belong inside .home-layout, not beside it: html/body set
                text-align:center and a black default colour, and .home-layout is
                what overrides them. A fixed overlay rendered as a sibling would
                render centred in the wrong font. */}
            {overlays}
        </div>
    );
}

/**
 * Heading row for a page inside the console — its <h2> and subtitle, with any
 * page-level action buttons pushed to the right.
 */
export function AdminPageHead({ title, subtitle, actions }) {
    return (
        <div className="admin-page-head">
            <div style={{ minWidth: 0 }}>
                <h2 className="admin-page-heading">{title}</h2>
                {subtitle && <p className="admin-page-sub">{subtitle}</p>}
            </div>
            {actions && <div className="page-title-actions">{actions}</div>}
        </div>
    );
}
